import { Button } from "@/components/ui/button";
import { BookmarkIcon, FlagIcon } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { isSavedHighlightedAtom, isVisitedHighlightedAtom } from "@/atoms/interactionHighlightAtom";

export type GlobalMenuMode = "A" | "B" | "C" | "D";

export type GlobalMenuProps = {
  active?: string;
  setActive?: (active: string) => void;
};

export const GlobalMenu = ({ setActive }: GlobalMenuProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isSavedHighlighted = useAtomValue(isSavedHighlightedAtom);
  const isVisitedHighlighted = useAtomValue(isVisitedHighlightedAtom);

  const currentPath = location.pathname;
  const isActive = (path: string) => {
    if (path === "/" && currentPath === "/") return true;
    if (path !== "/" && currentPath === path) return true;
    return false;
  };

  const handleNavigation = (path: string, activeState: string) => {
    navigate(path);
    setActive?.(activeState);
  };

  return (
    <div className="w-full pb-8" style={{ backgroundColor: "var(--footer-menu-gray)" }}>
      <div className="mx-auto max-w-md">
        <div className="flex items-center justify-around px-4 py-3">
          <Button
            size="icon"
            variant="ghost"
            className="flex h-14 flex-grow flex-col items-center justify-center gap-1 rounded-xl"
            onClick={() => handleNavigation("/visited", "visited")}
          >
            <FlagIcon
              className={`h-6 w-6 ${
                isActive("/visited") || isVisitedHighlighted ? "fill-current" : ""
              } ${isVisitedHighlighted ? "animate-pop" : ""}`}
              style={{
                color:
                  isActive("/visited") || isVisitedHighlighted
                    ? "var(--button-active-green)"
                    : "var(--text-dark-gray)"
              }}
            />
            <span
              className="text-xs font-medium"
              style={{
                color: isActive("/visited") ? "var(--button-active-green)" : "var(--text-dark-gray)"
              }}
            >
              行った
            </span>
          </Button>
          <Button
            className="flex h-14 w-20 items-center justify-center rounded-xl hover:bg-white/50"
            variant="ghost"
            onClick={() => handleNavigation("/", "home")}
          >
            <div className="h-16 w-16 flex-shrink-0">
              <div className="flex h-full w-full items-center justify-center p-2 transition-colors">
                <img src="/logo-icon.svg" alt="logo" className="h-12 w-12" />
              </div>
            </div>
          </Button>
          <Button
            size="icon"
            variant="ghost"
            className="flex h-14 flex-grow flex-col items-center justify-center gap-1 rounded-xl"
            onClick={() => handleNavigation("/saved", "saved")}
          >
            <BookmarkIcon
              className={`h-6 w-6 ${
                isActive("/saved") || isSavedHighlighted ? "fill-current" : ""
              } ${isSavedHighlighted ? "animate-pop" : ""}`}
              style={{
                color:
                  isActive("/saved") || isSavedHighlighted
                    ? "var(--button-active-green)"
                    : "var(--text-dark-gray)"
              }}
            />
            <span
              className="text-xs font-medium"
              style={{
                color: isActive("/saved") ? "var(--button-active-green)" : "var(--text-dark-gray)"
              }}
            >
              行きたい
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};
